import { useProfile } from './profile';

export function useIsSupplier() {
  const { data: profile } = useProfile();
  return !profile || Boolean(profile.supplier);
}
